import React, { useState } from "react";
// import { createRoot } from "react-dom/client";
import App from "./components/App_POC";
import "./index.css";
import ReactDOM from 'react-dom';
/* 
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from "./components/authConfig";
import { MsalProvider } from "@azure/msal-react";

const msalInstance = new PublicClientApplication(msalConfig); */

function changeTheme(theme) {
  document.documentElement.setAttribute('data-theme', theme);
  console.log("Theme value captured in index jsx :", theme);
}

function Index() {
  const [themeString, setThemeString] = useState(""); // No default theme

  const handleThemeChange = (newTheme) => {
    setThemeString(newTheme);
    changeTheme(newTheme); // This will apply the theme styles
  };
  //const root = ReactDOM.createRoot(document.getElementById('root'));

  return (
    <React.StrictMode>
      <App onThemeChange={handleThemeChange} />
      <div>
      </div>
    </React.StrictMode>
  );
}

ReactDOM.render(<Index />, document.getElementById("root"));